import api from "./api";

/**
 * Randevu / takvim uçları (backend: /api/appointments). Liste (takvim) düz dizi
 * döner: res.data.data = AppointmentResponse[]. from/to ISO tarih (YYYY-MM-DD).
 */
export const appointmentService = {
  calendar: (from, to) => api.get("/appointments", { params: { from, to } }),
  get: (id) => api.get(`/appointments/${id}`),
  create: (payload) => api.post("/appointments", payload),
  update: (id, payload) => api.put(`/appointments/${id}`, payload),
  setStatus: (id, status) => api.patch(`/appointments/${id}/status`, null, { params: { status } }),
  remove: (id) => api.delete(`/appointments/${id}`),
};
